import { createDryMassEntryOptionSelector } from 'Components/Worksheets/MoistureContentWorksheet';
import { pipe } from 'Lib/Hooks/Selectors';
import { useSelector } from 'react-redux';
import { WaterContentDryMassesSection } from '.';
import { DateTimeInput, Field, NumericInput, TextInput, TextOutput } from '../../../../Core';
import { NamePrefixModifier, withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { ListFieldSection, SectionGroup } from '../../../../Layout';
import { IWithWorksheetInjectedProps, WorksheetEquipmentDropdown } from '../../../Core';
import { WorksheetBalanceFieldSet } from '../../../Core/WorksheetEquipment';

const WaterContentMethodASectionBase: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const showTimeInOven = useSelector(
    pipe(createDryMassEntryOptionSelector(createWorksheetSelector!), (v) => v !== 'Never')
  );

  return (
    <SectionGroup heading="Water Content">
      <NamePrefixModifier appendNamePrefix="OvenDrying">
        {/* Equipment for wet masses */}
        <ListFieldSection>
          <NamePrefixModifier appendNamePrefix="Equipment">
            <WorksheetBalanceFieldSet name="Balance" />
            <Field input={<WorksheetEquipmentDropdown />} name="Oven" equipmentType="oven" />
            <Field input={<NumericInput />} name="DryingTemperature" />
          </NamePrefixModifier>
        </ListFieldSection>
      </NamePrefixModifier>

      {/* Wet masses */}
      {/* We need to redirect messages from another path which is why we don't prefix paths here */}
      <ListFieldSection>
        <Field input={<TextInput />} name="OvenDrying.DryingTray.ContainerLabel" />
        <Field
          input={<NumericInput />}
          name="OvenDrying.DryingTray.ContainerMass"
          additionalMessagePaths={['Combustion.TareMass']}
        />
        <Field input={<NumericInput />} name="OvenDrying.DryingTray.WetSoilAndContainerMass" />
        <Field input={<TextOutput />} name="OvenDrying.DryingTray.WetSoilMass" />
        {showTimeInOven && <Field input={<DateTimeInput />} name="OvenDrying.DryingTray.DateTimePlacedInOvenLocal" />}
      </ListFieldSection>

      <NamePrefixModifier appendNamePrefix="OvenDrying">
        <WaterContentDryMassesSection />
        {/* Results */}
        <ListFieldSection>
          <Field emph input={<TextOutput />} name="Results.MoistureContentPercent" />
        </ListFieldSection>
      </NamePrefixModifier>
    </SectionGroup>
  );
};

const WaterContentMethodASection = withInjectedProps(WaterContentMethodASectionBase);
export { WaterContentMethodASection };
export default WaterContentMethodASection;
